import React, {useEffect} from "react";
import Breadcrumb from "../Components/Breadcrumb";
import FeatureCard from "../Components/FeatureCard";
import { featurePageData } from "../Data";
import WhatsappAutomationSteps from "../Components/WhatsappAutomationSteps";
import Cta from "../Components/Cta";
import SchemaMarkup from '../Components/SchemaMarkup';
import WebPageSchema from "../Schema/WebpageSchema";
import ItemListSchema from "../Schema/ItemListSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import CollectionPageSchema from "../Schema/CollectionPageSchema";

const Features=()=>{

useEffect(() => {
    document.title =
      "ONBBITS Features | WhatsApp Automation Solutions";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Explore ONBBITS features including AI chatbots, no-code automation, shared inbox, broadcasts, CRM integrations and real-time analytics."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://onbbits.io/features");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "ONBBITS Features | WhatsApp Automation Solutions"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Explore ONBBITS features including AI chatbots, no-code automation, shared inbox, broadcasts, CRM integrations and real-time analytics."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://onbbits.io/features");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://onbbits.io/Images/contact-crm.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "ONBBITS Features | WhatsApp Automation Solutions"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Explore ONBBITS features including AI chatbots, no-code automation, shared inbox, broadcasts, CRM integrations and real-time analytics."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://onbbits.io/Images/contact-crm.webp"
    );
  }
  }, [])
  

    return(
        <>

      <SchemaMarkup
  data={WebPageSchema({
    type: "WebPage",
    name: "ONBBITS Features",
    description:
      "Explore ONBBITS WhatsApp automation features for customer engagement, campaigns, chatbots, shared inbox, analytics, and more.",
    url: "https://onbbits.io/features/"
  })}
/>

<SchemaMarkup
  data={ItemListSchema({
    name: "ONBBITS Features",
    items: [
      {
        name: "Flow Builder"
      },
      {
        name: "Agent Management"
      },
      {
        name: "Contact CRM"
      },
      {
        name: "Scheduled Reminders"
      },
      {
        name: "Broadcasts"
      },
      {
        name: "Team Inbox"
      },
       {
        name: "WhatsApp Forms"
      },
      {
        name: "Templates"
      },
        {
        name: "Flow Library"
      },
       {
        name: "Product Catalog"
      },
      {
        name: "API & Integrations"
      }
    ]
  })}
/>

<SchemaMarkup
  data={BreadcrumbSchema({
    items: [
      {
        name: "Home",
        url: "https://onbbits.io/"
      },
      {
        name: "Features",
        url: "https://onbbits.io/features/"
      }
    ]
  })}
/>

<SchemaMarkup
  data={CollectionPageSchema({
    name: "Industries",
    description:
      "Explore ONBBITS WhatsApp automation features for customer engagement, campaigns, chatbots, shared inbox, analytics, and more.",
    url: "https://onbbits.io/features/"
  })}
/>

         {/**BREADCRUMB */}
        <Breadcrumb title="Every tool your business needs to run WhatsApp at scale" />

        {/**FEATURE CARDS */}
        {featurePageData.map((item, index)=>(
        <FeatureCard
          key={item.id}
          item={item}
          reverse={index % 2 !== 0}
          imageBottom={item.id === 10}
        />
      ))}

      {/**AUTOMATE YOUR WHATSAPP SECTION */}
    <WhatsappAutomationSteps />

    <div style={{marginBottom:"-80px"}}></div>

    {/**CTA SECTION */}
    <Cta />
        </>
    )
}
export default Features;